import type { PaymentFormValues } from '../types';

export interface StripeBillingAddress {
  line1: string;
  city: string;
  postal_code: string;
  country: string;
}

export function billingAddressFromFormValues(values: PaymentFormValues): StripeBillingAddress {
  return {
    line1: values.addressLine,
    city: values.city,
    postal_code: values.postalCode,
    country: values.country,
  };
}

/** Billing for the second card in pay-in-full split when it differs from the first. */
export function billingAddressForSplitFullCard2(values: PaymentFormValues): StripeBillingAddress {
  if (values.billingAddressSameAsFirst) {
    return billingAddressFromFormValues(values);
  }
  return {
    line1: values.addressLine2,
    city: values.city2,
    postal_code: values.postalCode2,
    country: values.country2,
  };
}
